const module = {
  config: {
    name: "master",
    svg: "../static/img/icon/menu/master.svg",
    desc: "Berisi modul master data",
    layout: true
  },
  routes: [
    // Buku
    {
      name: "Daftar Buku",
      icon: "ri-book-fill",
      path: "/daftar-buku",
      component: () => import("./books/books.vue"),
      separator: "Buku"
    },
    // Penulis Buku
    {
      name: "Penulis Buku",
      icon: "ri-edit-fill",
      path: "/daftar-penulis-buku",
      component: () => import("./books/authors.vue"),
      separator: "Buku"
    },
    // Penerbit Buku
    {
      name: "Penerbit Buku",
      icon: "ri-building-fill",
      path: "/daftar-penerbit-buku",
      component: () => import("./books/publishers.vue"),
      separator: "Buku"
    },
    // Jenis Buku
    {
      name: "Jenis Buku",
      icon: "ri-record-circle-fill",
      path: "/daftar-jenis-buku",
      component: () => import("./books/types.vue"),
      separator: "Klasifikasi"
    },
    // Kategori Buku
    {
      name: "Kategori Buku",
      icon: "ri-bookmark-3-fill",
      path: "/daftar-kategori-buku",
      component: () => import("./books/categories.vue"),
      separator: "Klasifikasi"
    },
    // Tag Buku
    {
      name: "Tag Buku",
      icon: "ri-bookmark-fill",
      path: "/daftar-tag-buku",
      component: () => import("./books/tags.vue"),
      separator: "Klasifikasi"
    },
    // Kelas
    {
      name: "Daftar Kelas",
      icon: "ri-door-fill",
      path: "/daftar-kelas",
      component: () => import("./classes.vue"),
      separator: "Kelas"
    },
    // siswa
    {
      name: "Siswa",
      icon: "ri-graduation-cap-fill",
      path: "/daftar-siswa",
      component: () => import("./members/students.vue"),
      separator: "Anggota"
    },
    // Guru
    {
      name: "Guru",
      icon: "ri-presentation-fill",
      path: "/daftar-guru",
      component: () => import("./members/teachers.vue"),
      separator: "Anggota"
    },
    // Karyawan
    {
      name: "Karyawan",
      icon: "ri-user-2-fill",
      path: "/daftar-karyawan",
      component: () => import("./members/employees.vue"),
      separator: "Anggota"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/master/_index.js